import {Grid, TextField} from '@material-ui/core';
import React, {useEffect, useMemo, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";

import {FlightNumber, FormDialog, MaskedNumber, MaskedText} from "../../../../controls";
import Validator from "../../validators/MultiFlightSelectValidator";
import FlightListLookup from "../../../Flights/components/FlightListOnDLookup";
import FlightsMultiSelect from "../../../Flights/components/FlightsMultiSelect";
import axios from 'axios';
import { getApiSitePrefix } from "../../../../functions/SiteDefaults";
const apiSitePrefix = getApiSitePrefix();

const MultiFlightSelectDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const formatChars = props.formatChars;
  const airportCode = props.airportCode;
  const fromDate = props.fromDate;
  const orderLines = props.lines
  const preSelection = props.preSelection;

  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    noteUuid: null,
    title: 'Select Flights to add to Order'
  });

  const DisplayForm = () => {

      return (
        <FormDialog
          title={dialogState.title}
          message="Select one or more flights to add to the order"
          open={dialogState.showDialog}
          record={{airlineCode: "", flightNo: ""}}
          dialogOptions={{width: "xs", maxWidth: "xs", fullWidth: true}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "add_box", key: "Update", label: "Add Flights", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              const orderLines = [];
              if (record.selectedFlights && Array.isArray(record.selectedFlights)) {
                record.selectedFlights.forEach(flight => {
                  const legType = flight.legType;
                  const orderLine = {
                    tripLegUuid: flight.tripLegUuid,
                    airportCode: airportCode,
                    direction: preSelection ? flight.direction : airportCode===flight.originAirportCode?'OUT':'IN',
                    scheduledTimeUTC:airportCode===flight.originAirportCode?flight.scheduledDepartureTimeUTC:flight.scheduledArrivalTimeUTC,
                    airlineCode: flight.airlineCode,
                    flightNo: flight.flightNo,
                    flightNumber: flight.airlineCode + flight.flightNo,
                    aircraftType: "B747F",
                    aircraftTailNumber: preSelection ? flight.aircraftTailNumber : flight.aircraftReg,
                    originAirportCode: flight.originAirportCode,
                    arrivalDate: flight.arrivalDate,
                    scheduledArrivalTimeUTC: preSelection ? flight.scheduledArrivalTimeUTC : flight.arrivalTime,
                    destinationAirportCode: flight.destinationAirportCode,
                    departureDate: preSelection ? moment.utc(flight.departureDate).format("YYYY-MM-DD") : moment.utc(flight.scheduledDepartureTimeUTC).format("YYYY-MM-DD"),
                    scheduledDepartureTimeUTC: preSelection ? flight.scheduledDepartureTimeUTC : moment.utc(flight.scheduledDepartureTimeUTC).format("HH:mm"),
                    cargo: legType ? (legType === "FERRY" ? "Empty Ferry" : legType === "FULL CHARTER" ? "100 Metric Tonnes" : legType === "PART CHARTER" ? "50 Metric Tonnes" : "") : flight.cargo,
                    serviceProviderUuid: flight.serviceProviderUuid,
                    companyName: flight.companyName
                  }
                  orderLines.push(orderLine);
                });
                if (props.onChange)
                axios.put(`${apiSitePrefix}/handlingorders/getPayloadData`, {lines: orderLines})
                .then (response => {
                  if (!response || !response.data || !Array.isArray(response.data) || response.data.length < 1) {
                    SystemData.alert("Error", `An unexpected error occurred preparing handling order selection`);
                    return;
                  }
                  const lines = response.data;
            
                  props.onChange(lines);
                  setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
                })
              }
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            }
          }}
        >
          <Grid container checkChildren={true} spacing={3}>
            <Grid item xs={12} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                <FlightNumber
                  id="flightNumber"
                  label="Filter Flights"
                  mask={"aX-999aa"}
                  code={record.airlineCode}
                  number={record.flightNo}
                  //inputProps={defaultEditProps}
                  onChange={(e, props) => {
                    const data = {
                      ...props.record,
                      airlineCode: e.code,
                      flightNo: e.number,
                      flightNumber: e.code + e.number
                    }
                    props.recordChange(data);
                  }}
                />
              }
            </Grid>
            <Grid item xs={12} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                preSelection
                  ?
                    <FlightsMultiSelect
                      id="flightMultiSelect"
                      width={300}
                      classes={classes}
                      canEdit={dialogState.canEdit}
                      airportCode={airportCode}
                      fromDate={fromDate}
                      airlineCode={record.airlineCode}
                      flightNo={record.flightNo}
                      flights={orderLines}
                      onChange={(flights, props)=>{
                        changeRecord({selectedFlights: flights});
                      }}
                    />
                  :
                    <FlightListLookup
                      id="flightListLookup"
                      width={300}
                      classes={classes}
                      canEdit={dialogState.canEdit}
                      airportCode={airportCode}
                      fromDate={fromDate}
                      airlineCode={record.airlineCode}
                      flightNo={record.flightNo}
                      orderLines={orderLines}
                      onChange={(flights, props)=>{
                        changeRecord({selectedFlights: flights});
                      }}
                    />
              }
            </Grid>
          </Grid>
        </FormDialog>
      )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title});
    }
    eventBus.bind("FlightListLookup.open", open);
    return () => {
      eventBus.unbind("FlightListLookup.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default MultiFlightSelectDialog;
